module.exports = __webpack_public_path__ + "0547b9634c7b2903b805a2253fb711f2.jpg";